import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J207 (研發領用單)
// ============================================================

export interface FJ170 {
  fj170_01: string;          // 領用單號 (PK)
  fj170_10: string;          // 研發托工單號(來源)
  fj170_11: string | null;   // 領用日期 (ISO string)
  fj170_12: string;          // 備用欄位
  fj170_13: string;          // 說明
  fj170_14: number;          // 明細筆數
  fj170_15: string;          // 部門
  fj170_16: string;          // 建立人員
  fj170_17: string | null;   // 備用日期
  fj170_80: string;          // 核准狀態 N/P
  fj170_89: string;          // 備用欄位
  fj170_90: number;          // version
  fj170_91: string;          // modifier
  fj170_92: string | null;   // modify date
  fj170_93: string;          // modify note
  details?: FJ171[];
}

export interface FJ171 {
  fj171_01: string;          // 領用單號 FK
  fj171_02: number;          // 項次
  fj171_10: string;          // 產品大類碼
  fj171_11: string;          // 產品細類碼
  fj171_12: string;          // 庫位代號
  fj171_13: string;          // 批號
  fj171_14: string;          // 單位
  fj171_15: number;          // 領用量
  fj171_16: number;          // 金額
  fj171_17: number;          // 換算係數
  fj171_18: string;          // 色號
  fj171_19: number;          // 領用金額
  fj171_90: number;
  // F113 reference fields (read-only, from backend JOIN)
  f113_22?: number;           // 針孔內
  f113_26?: number;           // 針孔外
  f113_24?: number;           // 碼重
  f113_241?: number;          // 米平方重
}

// ============================================================
// Request / Response types
// ============================================================

export interface J207ListResponse {
  data: FJ170[];
  total: number;
  page: number;
  size: number;
}

export interface J207CreateRequest {
  master: Partial<FJ170>;
  details: Partial<FJ171>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j207Api = {
  async list(page = 1, size = 20): Promise<J207ListResponse> {
    const res = await apiClient.get('/api/j207', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FJ170> {
    const res = await apiClient.get(`/api/j207/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: J207CreateRequest): Promise<FJ170> {
    const res = await apiClient.post('/api/j207', data);
    return res.data;
  },

  async update(id: string, data: J207CreateRequest): Promise<FJ170> {
    const res = await apiClient.put(`/api/j207/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/j207/${encodeURIComponent(id)}`);
  },
};
